<template>
  <main class="p20 bg-white main">
    <div class="mt20 mb20">
      <span class="title1">库存管理</span>
    </div>
    <div class="search-one" style="margin-top: 70px;">
      <div class="search-item">
        入库单号<Input class='ml10 mr20 w200' v-model="screen_data.in_bill_no" placeholder="请输入入库单号" clearable/>
        快递单号<Input class='ml10 mr20 w200' v-model="screen_data.waybill_code" placeholder="请输入快递单号" clearable/>

        客户编号<Input class='ml10 mr20 w200' v-model="screen_data.client_code" placeholder="请输入客户编号" clearable/>

      </div>
      <div class="search-item">
        状态
        <Select v-model="screen_data.in_bill_status" class="ml10" clearable>
          <Option value="0">在库</Option>
          <Option value="10">待发货</Option>
          <Option value="20">已发货</Option>
        </Select>
        入库时间
        <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200'></DatePicker>
        <!-- -
        <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200'></DatePicker> -->
        <button class="ivu-btn ivu-btn-primary fr" @click="search">搜索</button>
      </div>


    </div>
    <Table :loading="loading" class="mt20" border :columns="table_data.columns" :data="table_data.data">
      <template slot-scope="{ row, index }" slot="images">
        <span class="item-img mr10 fl" v-for="(v,i) in row.image_arr" :key="i" :src="v">
          <el-image style="width: 30px; height: 30px;margin-top: 10px;" :src="v" :preview-src-list="row.image_arr">
          </el-image>
        </span>
      </template>
    </Table>
    <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>

    <!-- 声音组件 -->
    <Voice ref="child"></Voice>
    <VoiceText ref="voiceText"></VoiceText>
  </main>
</template>

<script>
  import Paging from '@/components/common/paging';
  import Voice from "@/components/common/voice";
  import VoiceText from "@/components/common/voice.text";
  export default {
    components: {
      Paging,
      Voice,
      VoiceText
    },
    data() {
      return {
        is_preview: localStorage.getItem("is_preview") == 'true' ? true : false, //是否打印预览
        error_msg: '', //错误信息
        img: '',
        table_data: { //列表数据
          columns: [],
          data: []
        },
        loading: true, //是否加载中
        screen_data: { //传入接口的搜索条件
          pageNum: 1,
          pageSize: 10,
          warehouse_id: ''
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
      }
    },
    methods: {
      init() {
        this.table_data.columns = this.setColumns();
      },
      del(in_bill_no) { //删除
        this.$Modal.confirm({
          title: '温馨提示',
          content: '<p> 您正在删除包裹号为' + in_bill_no + '的包裹，确认要进行此操作吗？</p>',
          onOk: () => {
            this.$axios.delete("/fh/in/bill?in_bill_no=" + in_bill_no)
              .then(res => {
                if (res.success && res.data) {
                  this.$Message.info('删除成功')
                  this.search()
                }
              })
          },
          onCancel: () => {

          }
        });
      },
      sDateChange(e) {
        if (e) {
          this.screen_data.create_date = e + ' 00:00:00'
        } else {
          this.screen_data.create_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screen_data.create_end_date = e + ' 23:59:59'
        } else {
          this.screen_data.create_end_date = ''
        }
      },

      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList();
      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList();
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList();
      },
      /*
       * 获取列表
       */
      getList() {
        this.$axios.get("/fh/in/bill/list", {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            this.table_data.data = res.data;
          } else {
            this.table_data.data = []
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      exportData() {
        this.$axios.get("/user/list/excel", {
          params: this.screen_data
        }).then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      },
      setColumns() {
        let arr = [];
        arr = [{
          title: '入库单号',
          key: 'in_bill_no',
          tooltip: true,
          width: 180,
          fixed: 'left'
        }, {
          title: '快递单号/物流单号',
          key: 'waybill_code',
          tooltip: true,
          width: 170,
        }, {
          title: '账号编号',
          key: 'client_code',
          tooltip: true,
          width: 150,
        },{
          title: '账户姓名',
          key: 'client_code_name',
          width: 150,
        }, {
          title: '客户名称',
          key: 'client_name',
          tooltip: true,
          width: 200,
        },  {
          title: '状态',
          width: 185,
          render: (h, params) => {
            let showText = "";
            switch (params.row.in_bill_status) {
              case 0:
                showText = "在库";
                break;
              case 10:
                showText = "待发货";
                break;
              case 20:
                showText = "已发货";
                break;
            }
            return h("span", showText);
          }
        }, {
          title: '重量',
          key: 'weight',
          width: 150,
        }, {
          title: '入库时间',
          key: 'create_date',
        }];
        return arr;
      }
    },
    created() {
      this.screen_data.warehouse_id = localStorage.getItem('warehouse_id');
      if (this.screen_data.warehouse_id) {
        this.getList();
      } else {
        this.$Message.info('请选择仓库')
      }
      this.init();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/zhongzhuanfahuo/stock/list.vue